import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import toast from "react-hot-toast";

const NAV = [
  { to: "/admin", label: "Dashboard", icon: "◈", end: true },
  { to: "/admin/posts", label: "All Posts", icon: "◉" },
  { to: "/admin/posts/new", label: "New Post", icon: "+" },
  { to: "/admin/members", label: "Members", icon: "◎" },
  { to: "/admin/uploads", label: "Media", icon: "⊕" },
  { to: "/admin/newsletter", label: "Newsletter", icon: "✉" },
];

export default function AdminLayout({ children }) {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    toast.success("Logged out.");
    navigate("/");
  };

  const sidebarContent = (
    <div style={{
      width: 240,
      minHeight: "100vh",
      background: "var(--bg-secondary)",
      borderRight: "1px solid var(--border)",
      display: "flex",
      flexDirection: "column",
      position: "fixed",
      top: 0,
      left: sidebarOpen ? 0 : undefined,
      zIndex: 100,
      padding: "24px 0",
    }}>
      {/* Logo */}
      <div style={{ padding: "12px 24px 32px" }}>
        <div style={{ fontFamily: "var(--font-serif)", fontSize: "1.2rem", color: "var(--text-primary)" }}>MacroEdge</div>
        <div style={{ fontFamily: "var(--font-mono)", fontSize: "9px", letterSpacing: "0.2em", color: "var(--gold)", textTransform: "uppercase", marginTop: 2 }}>Admin Panel</div>
      </div>

      {/* Navigation */}
      <nav style={{ flex: 1, padding: "0 12px" }}>
        {NAV.map(item => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            onClick={() => setSidebarOpen(false)}
            style={({ isActive }) => ({
              display: "flex",
              alignItems: "center",
              gap: 12,
              padding: "10px 12px",
              marginBottom: 2,
              borderRadius: "var(--radius)",
              fontFamily: "var(--font-body)",
              fontSize: "14px",
              color: isActive ? "var(--gold)" : "var(--text-secondary)",
              background: isActive ? "var(--gold-dim)" : "transparent",
              transition: "all 0.2s",
              textDecoration: "none",
            })}
          >
            <span style={{ fontSize: "0.9rem", width: 18, textAlign: "center" }}>{item.icon}</span>
            {item.label}
          </NavLink>
        ))}
      </nav>

      {/* Bottom */}
      <div style={{ padding: "16px 24px", borderTop: "1px solid var(--border)" }}>
        <a href="/" target="_blank" rel="noreferrer" style={{
          display: "block",
          fontFamily: "var(--font-mono)",
          fontSize: "11px",
          color: "var(--text-muted)",
          letterSpacing: "0.1em",
          marginBottom: 12,
          transition: "color 0.2s",
        }}
          onMouseEnter={e => e.target.style.color = "var(--text-primary)"}
          onMouseLeave={e => e.target.style.color = "var(--text-muted)"}
        >
          ↗ VIEW SITE
        </a>
        <button onClick={handleLogout} style={{
          width: "100%",
          background: "none",
          border: "1px solid var(--border-light)",
          color: "var(--text-muted)",
          padding: "8px",
          borderRadius: "var(--radius)",
          fontFamily: "var(--font-mono)",
          fontSize: "11px",
          letterSpacing: "0.1em",
          cursor: "pointer",
          textTransform: "uppercase",
          transition: "all 0.2s",
        }}
          onMouseEnter={e => { e.target.style.color = "#e05252"; e.target.style.borderColor = "#e0525233"; }}
          onMouseLeave={e => { e.target.style.color = "var(--text-muted)"; e.target.style.borderColor = "var(--border-light)"; }}
        >
          Logout
        </button>
      </div>
    </div>
  );

  return (
    <div style={{ display: "flex", minHeight: "100vh", background: "var(--bg-primary)" }}>
      {/* Desktop Sidebar */}
      <div className="admin-sidebar-desktop">
        {sidebarContent}
      </div>

      {/* Mobile overlay */}
      {sidebarOpen && (
        <div
          onClick={() => setSidebarOpen(false)}
          style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.7)", zIndex: 99 }}
        />
      )}
      {sidebarOpen && (
        <div className="admin-sidebar-mobile" style={{ position: "fixed", top: 0, left: 0, zIndex: 100 }}>
          {sidebarContent}
        </div>
      )}

      {/* Main content */}
      <div style={{ flex: 1, marginLeft: 240, minHeight: "100vh", display: "flex", flexDirection: "column" }} className="admin-main">
        {/* Top bar (mobile) */}
        <div style={{
          display: "none",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "16px 20px",
          background: "var(--bg-secondary)",
          borderBottom: "1px solid var(--border)",
          position: "sticky",
          top: 0,
          zIndex: 50,
        }} className="admin-topbar">
          <div style={{ fontFamily: "var(--font-serif)", fontSize: "1.1rem" }}>MacroEdge Admin</div>
          <button onClick={() => setSidebarOpen(true)} style={{
            background: "none", border: "1px solid var(--border-light)",
            color: "var(--text-primary)", padding: "8px 12px",
            borderRadius: "var(--radius)", cursor: "pointer", fontSize: "18px",
          }}>☰</button>
        </div>

        <div style={{ flex: 1, padding: "32px" }}>
          {children}
        </div>
      </div>

      <style>{`
        @media (max-width: 900px) {
          .admin-sidebar-desktop { display: none !important; }
          .admin-topbar { display: flex !important; }
          .admin-main { margin-left: 0 !important; }
        }
      `}</style>
    </div>
  );
}
